// extracted by css-extract-rspack-plugin
export default {"button_override":"mEL8q","buttonOverride":"mEL8q","#":"ueNKE","mobile_auth_override":"JT6NA","mobileAuthOverride":"JT6NA","icon":"raha7","label":"jnhog"};